<template>
  <a-modal
    :title="'保证金明细详情'"
    :visible="visible"
    :footer="null"
    :width="800"
    @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <a-descriptions bordered :column="2">
        <a-descriptions-item :label="'ID'">{{ detail.id }}</a-descriptions-item>
        <a-descriptions-item :label="'店铺名称'">{{ detail.shopName }}</a-descriptions-item>
        <a-descriptions-item :label="'用户名称'">{{ detail.userName }}</a-descriptions-item>
        <a-descriptions-item :label="'用户手机号'">{{ detail.userPhone }}</a-descriptions-item>
        <a-descriptions-item :label="'记录类型'">
          <a-tag v-if="detail.recordType === 1" color="green">{{ '缴纳保证金' }}</a-tag>
          <a-tag v-else-if="detail.recordType === 2" color="blue">{{ '退还保证金' }}</a-tag>
          <a-tag v-else color="red">{{ '售后扣除' }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="'金额'">
          <span :style="{ color: detail.recordType === 1 ? 'green' : 'red' }">
            {{ detail.amount }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item :label="'最高日提现额度'" v-if="detail.recordType === 1">
          {{ detail.dailyWithdrawLimit }}
        </a-descriptions-item>
        <a-descriptions-item :label="'审核状态'">
          <a-tag v-if="detail.auditStatus === 1" color="orange">{{ '待审核' }}</a-tag>
          <a-tag v-else-if="detail.auditStatus === 2" color="green">{{ '审核通过' }}</a-tag>
          <a-tag v-else color="red">{{ '审核拒绝' }}</a-tag>
        </a-descriptions-item>
      </a-descriptions>

      <a-divider orientation="left">{{ '详细信息' }}</a-divider>

      <a-descriptions bordered :column="1" >
        <a-descriptions-item :label="'支付凭证'" v-if="detail.recordType === 1">
          <a v-for="(image, index) in payVoucherImages" :key="index" :href="image" target="_blank" style="margin-right: 10px;">
            <a-avatar :src="image" :size="60" shape="square" />
          </a>
        </a-descriptions-item>
        <a-descriptions-item :label="'收款方名称'">{{ detail.payeeName }}</a-descriptions-item>
        <a-descriptions-item :label="'开户行'">{{ detail.payeeBank }}</a-descriptions-item>
        <a-descriptions-item :label="'收款账号'">{{ detail.payeeAccount }}</a-descriptions-item>
      </a-descriptions>

      <a-descriptions bordered :column="1" v-if="detail.recordType === 2 || detail.recordType === 3">
<!--        <a-descriptions-item :label="'退还/扣除原因'">{{ detail.refundReason }}</a-descriptions-item>-->
        <a-descriptions-item :label="'关联订单ID'" v-if="detail.orderId">{{ detail.orderId }}</a-descriptions-item>
        <a-descriptions-item :label="'退款单号'" v-if="detail.refundNo">{{ detail.refundNo }}</a-descriptions-item>
      </a-descriptions>

      <a-divider orientation="left">{{ '审核信息' }}</a-divider>

      <a-descriptions bordered :column="2">
        <a-descriptions-item :label="'审核状态'">
          <a-tag v-if="detail.auditStatus === 1" color="orange">{{ '待审核' }}</a-tag>
          <a-tag v-else-if="detail.auditStatus === 2" color="green">{{ '审核通过' }}</a-tag>
          <a-tag v-else color="red">{{ '审核拒绝' }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="'审核时间'">{{ formatDate(detail.auditTime) }}</a-descriptions-item>
        <a-descriptions-item :label="'审核人'">{{ detail.auditUserName }}</a-descriptions-item>
        <a-descriptions-item :label="'审核备注'">{{ detail.auditRemark }}</a-descriptions-item>
      </a-descriptions>

      <a-divider orientation="left">{{ '其他信息' }}</a-divider>

      <a-descriptions bordered :column="2">
        <a-descriptions-item :label="'创建时间'">{{ formatDate(detail.createTime) }}</a-descriptions-item>
        <a-descriptions-item :label="'修改时间'">{{ formatDate(detail.updateTime) }}</a-descriptions-item>
        <a-descriptions-item :label="'备注'">{{ detail.remark }}</a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-modal>
</template>

<script>
import { getShopDepositRecord } from '@/api/shop/shopDepositRecord'

export default {
  name: 'ShopDepositRecordDetailDialog',
  data() {
    return {
      visible: false,
      loading: false,
      detail: {}
    }
  },
  computed: {
    payVoucherImages() {
      if (!this.detail.payVoucherImages) return []
      try {
        return JSON.parse(this.detail.payVoucherImages)
      } catch (e) {
        return []
      }
    }
  },
  methods: {
    /** 打开对话框 */
    open(id) {
      this.visible = true
      this.loading = true
      getShopDepositRecord(id).then(response => {
        this.detail = response.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 关闭对话框 */
    handleCancel() {
      this.visible = false
      this.detail = {}
    },
    formatDate(time) {
      if (!time) return '-'
      return this.parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
}
</script>

<style scoped>
</style>
